import "../../css/contact1.css";

function ContactSection1() {
  return (
    <section id="contact1" className="contact1">
      <div class="container">
        <div class="header">
          <h1>Contactar Voila Consulting</h1>
          <p>¿Listo para transformar tu negocio? Ponte en contacto con nuestro equipo de expertos y conversemos sobre cómo podemos ayudarte a alcanzar tus objetivos.</p>
        </div>

        <div class="contact-grid">
          <div class="contact-card whatsapp-card">
            <div class="contact-icon">
              <img src={require(`../../img/whatsapp.png`)} alt={"Whatsapp pic"} className="whatsapp-picture" />
            </div>
            <div class="contact-title">Envianos un WhatsApp</div>
            <div class="contact-description">
               Obtén respuestas instantáneas y una consulta rápida. Nuestro equipo está disponible para conversar sobre los requisitos de tu proyecto y brindarte asistencia inmediata.
            </div>
            <a href="https://wa.me/51924654344?text=Hola Voila Consulting, estoy interesado en tus servicios, me podrias comentar mas sobre ello." class="contact-button whatsapp-button" target="_blank" rel="noopener noreferrer">
              💬 Chatear en WhatsApp
            </a>
          </div>

          <div class="contact-card">
            <div class="contact-icon">
              📧
            </div>
            <div class="contact-title">Envianos un Correo</div>
            <div class="contact-description">
              Envíanos un mensaje detallado sobre tu proyecto. Te responderemos en un plazo de 24 horas con un plan de consultoría integral adaptado a tus necesidades.
            </div>
            <a href="mailto:lopezh_stefani@gmail.com?subject=Service Inquiry&body=Hola Equipo de Voila Consulting,%0D%0A%0D%0AEstoy interesado en aprender y saber mas sobre sus servicios. Porfavor contactenme para hablar sobre mis requerimientos de proyecto.%0D%0A%0D%0A¡Muchas gracias!" class="contact-button email-button">
              ✉️ Enviar Correo
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ContactSection1;